import { getCookie } from 'cookies-next/client';

import { FORCE_EXPERIMENT_VARIANTS_NAME } from '@/constants/cookies';
import { isServerCheck } from '@/modules/env/isServerCheck';

const headers = import('next/headers');

export async function getForcedVariantExperiments() {
  const headersFunction = await headers;

  if (isServerCheck()) {
    return (await headersFunction.cookies()).get(FORCE_EXPERIMENT_VARIANTS_NAME)
      ?.value;
  }
  return getCookie(FORCE_EXPERIMENT_VARIANTS_NAME);
}
